module.exports = __webpack_public_path__ + "img/code_ks.3d452f4b.png";